import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BehaviorSubject, catchError, Observable, of, tap, throwError} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {UserDetail} from '../models/userDetail';
import {credentialHttpOptionsJson} from '../http.options';

export interface UserLoadSelect {
  IDAccount: number;
  nominativo: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    userApiUrl = environment.apiAuthUrl + '/user';
    columns: string[] = []
    dataSource: any[] = [];
    public userSubject = new BehaviorSubject<any>(this.dataSource);

    constructor(private http: HttpClient, private _snackBar: MatSnackBar) {
        this.userSubject.next(true)
    }

    getUsers(): Observable<any> {
        return this.http.get<any>(this.userApiUrl, credentialHttpOptionsJson).pipe(
            tap((res) => {
                this.columns = res.rows[0];
                this.dataSource = res.rows.slice(1).map((row: any[]) => {
                    const rowData: any = {};
                    this.columns.forEach((header, index) => {
                        rowData[header] = row[index];
                    });
                    return rowData;
                });
            }),
            map(() => this.dataSource),
            catchError((err) => {
                console.error('Error fetching users', err);
                return of([]);
            })
        );
    }

    deleteUser(IDAccount: number): Observable<any> {
        return this.http.delete<void>(this.userApiUrl + "/" + IDAccount, {withCredentials: true}).pipe(
            tap(() => {
                this.dataSource = this.dataSource.filter(item => item.IDAccount !== IDAccount);
                this.userSubject.next(this.dataSource);
            }),
            catchError((error) => {
                return throwError(() => new Error(error));
            })
        );


    }

    getUserById(id: number): Observable<UserDetail | null> {
        return this.http.get<UserDetail>(this.userApiUrl + "/" + id, {withCredentials: true}).pipe(
            catchError((err) => {
                console.error('Error fetching user', err);
                return of(null);
            })
        );
    }

    updateUser(user: UserDetail) {
        return this.http.post<any>(this.userApiUrl, user, credentialHttpOptionsJson).pipe(
            catchError((err) => {
                console.error('Error updating user', err);
                return of(null);
            })
        )
    }

    createUser(user: UserDetail) {
        return this.http.post<any>(this.userApiUrl, user, credentialHttpOptionsJson).pipe(
            catchError((err) => {
                console.error('Error creating user', err);
                return of(null);
            })
        )
    }

    openSnackBar(message: string, action: string = '', duration: number = 3): void {
        this._snackBar.open(message, action, {duration: duration * 1000});
    }

  loadSelect(accountType: string): Observable<any> {
    const body = {"accountType": [accountType]};
    return this.http.post<any>(this.userApiUrl + "/loadSelect", body, {withCredentials: true}).pipe();
  }
}
